import { MODEL_USE_CASES } from '@erikdakoda/ai-model/shared/modelPolicy';
import { ReasoningEffort as ReasoningEffortEnum } from '@erikdakoda/database/enums';
import { z } from 'zod';

/** Shared Zod schema for per-run Bot inference overrides. */
export const botOverridesSchema = z.object({
  modelOverride: z
    .string()
    .optional()
    .describe('Override model. Format: "integration#modelName" e.g. "openai#gpt-5-mini".'),
  useCase: z
    .enum(MODEL_USE_CASES)
    .nullable()
    .optional()
    .describe('Use case for this run. Null runs the named model alone.'),
  integration: z.string().nullable().optional().describe('Integration of the model for this run.'),
  modelName: z
    .string()
    .nullable()
    .optional()
    .describe('Catalog model for this run. Null with a use case means Auto.'),
  systemPromptOverride: z.string().optional().describe("Replace the Bot's system prompt entirely."),
  systemPromptAppend: z
    .string()
    .optional()
    .describe("Append extra instructions to the Bot's system prompt."),
  temperature: z.number().min(0).max(2).optional().describe('Override temperature.'),
  reasoningEffort: z.enum(ReasoningEffortEnum).optional().describe('Override reasoning effort.'),
  maxSteps: z.number().min(1).default(500).describe('Max tool-use steps the sub-agent may take.'),
});
